import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

export const GroupPasswordIcon = () => {
  const theme = useTheme();
  const { mode } = theme.palette;
  return (
    <SvgIcon
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3532 24.174H21.5345L21.5242 19.8746L21.5345 19.6413C21.5345 18.3476 22.6568 17.2429 23.9504 17.2429C25.2439 17.2429 26.3632 18.3476 26.3632 19.6413L26.3529 19.4263C26.3529 19.4263 26.9066 20.3747 26.7265 20.4576C26.7102 20.4654 26.3529 20.4576 26.3529 20.4576V21.0795H27.5342L27.5445 19.6413C27.5445 17.7008 25.8907 16.0716 23.9504 16.0716C22.01 16.0716 20.3532 17.7008 20.3532 19.6413L20.3429 19.8746"
        fill={mode === 'dark' ? '#fff' : '#383838'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5102 22.9539H20.2902ZM24.5592 26.9909C24.7462 26.8229 24.8642 26.5799 24.8642 26.3089C24.8642 25.8029 24.4552 25.3939 23.9492 25.3939C23.4442 25.3939 23.0342 25.8029 23.0342 26.3089C23.0342 26.5799 23.1522 26.8229 23.3392 26.9909V28.4429H24.5592V26.9909ZM20.2902 22.9539H19.6802C19.0062 22.9539 18.4602 23.4999 18.4602 24.1739V29.6629C18.4602 30.3369 19.0062 30.8829 19.6802 30.8829H28.2192C28.8922 30.8829 29.4382 30.3369 29.4382 29.6629V24.1739C29.4382 23.4999 28.8922 22.9539 28.2192 22.9539H21.5102"
        fill={mode === 'dark' ? '#fff' : '#383838'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.9492 24.0479C47.9232 37.2759 37.1782 47.9789 23.9492 47.9519C10.7212 47.9259 0.018217 37.1809 0.045217 23.9519L4.03721 23.9599C4.01522 34.9839 12.9342 43.9379 23.9572 43.9599C34.9812 43.9819 43.9352 35.0639 43.9572 24.0399C43.9792 13.016 35.0612 4.06197 24.0372 4.03997L24.0452 0.0479736C37.2732 0.0739736 47.9762 10.819 47.9492 24.0479Z"
        fill="#008075"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0212 12.024C17.4072 12.011 12.0342 17.3619 12.0212 23.9759C12.0082 30.5899 17.3592 35.9629 23.9732 35.9759L23.9652 39.9679C15.1462 39.9509 8.01121 32.7869 8.02921 23.9679C8.04621 15.1489 15.2102 8.01396 24.0292 8.03196C32.8482 8.04896 39.9832 15.2129 39.9652 24.0319L35.9732 24.0239C35.9862 17.4099 30.6352 12.037 24.0212 12.024Z"
        fill="#C2FE06"
      />
    </SvgIcon>
  );
};
